import { render } from "./system.vue?vue&type=template&id=78e575a1"
const script = {}

import exportComponent from "D:\\WorkFile\\Project\\uniapp-bajitu-user\\web-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__